module.exports = __webpack_public_path__ + "b562d009b1418a249d5fa0060abb2afd.png";